import React, { useState } from "react";
import { Button, Col, Row, Typography, Breadcrumb } from "antd";
import { Link, useParams } from "react-router-dom";

import { translate } from "../../../locale";
import EmailsTable from "../../../components/Tables/EmailsTable";
import SendNotification from "../../../components/Modals/SendNotification";

const { Title } = Typography;

const Emails = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [reloadTable, setReloadTable] = useState(null);
  const { username } = useParams();

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const handleModalComplete = () => {
    // update user list
    setModalVisible(false);
    setReloadTable((v) => v + 1);
  };

  const handleSendEmail = () => {
    setModalVisible(true);
  };

  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row>
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/buscar-paciente/${username}`}>
                {translate("Resumen individual")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{translate("Emails")}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center">
            {translate("Emails")}
          </Title>
        </Col>

        <Col className="gutter-row" span="12">
          <div className="text-start">
            <Button
              type="primary"
              className="bg-custom_primary border-custom_primary"
              onClick={handleSendEmail}
            >
              {translate("Enviar email")}
            </Button>
            <SendNotification
              patient={username}
              visible={modalVisible}
              onCancel={handleModalCancel}
              onComplete={handleModalComplete}
            />
          </div>
        </Col>

        <Col span="24" className="mt-6">
          <EmailsTable reload={reloadTable} />
        </Col>
      </Row>
    </div>
  );
};

export default Emails;
